var Thread = require('./thread');

function Feedback(app){
	var self = this;
	self.app = app;
}

Feedback.prototype.thread = function(){
	var self = this;
	return new Thread(self.app);
}

module.exports = Feedback;